export default __webpack_public_path__ + "static/media/_table-sort-descend-icon.261d337e.svg";